import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { DialogListSection, type DialogListSectionProps } from '../dialogsListSection/DialogListSection';
import { SessionDetails } from '../SessionDetails/SessionDetails';

type Props = {
  listSection?: FC<DialogListSectionProps>;
};

export const DialogsClassicLayout: FC<Props> = ({ listSection }) => {
  const { id } = useParams<{ id: string }>();
  const ListSection = listSection ?? DialogListSection;

  if (!id) {
    return <ListSection className="h-full relative " />;
  }

  return (
    <div className={'grid grid-rows-[1fr] grid-cols-1 gap-4 h-full'}>
      <SessionDetails id={+id} />
    </div>
  );
};
